window.odTheme = window.odTheme || {};

window.odTheme.MegaMenu = (function() {
  
  function MegaMenu(){
    this.data = {
      activeMenu: {},
      active: false,
      megaMenu: [],
      tier_1: {},
      tier_2: {},
      tier_3: {}
    };

    this.featuredLinkPrefix = 'All';
    this.getMenuData();
    this.bindEvents();
  }

  MegaMenu.prototype = window.odTheme.utils.extend({}, MegaMenu.prototype, {

    getMenuData: function($section) {
      var self = this;

      var menuHtmlCollectionData = document.getElementById('Navigation').children;
      var megaMenuData = Array.from(menuHtmlCollectionData);

      var parentGroup,subGroup,childGroup;

      for (var i = 0; i < megaMenuData.length; i++) {
        var item = megaMenuData[i];
        let left = 0;
        let title = item.innerText.toLowerCase();
        title = title.split(' ').join('-').replaceAll("'", "");
        let parentButton = document.querySelector(`[data-menu="${title}"]`);
        if (parentButton){
          left = parentButton.offsetLeft + 'px'
        }
        var group = {
          title: item.innerText,
          level: parseInt(item.dataset.level),
          url: item.href,
          handle: title,
          parentHandle: '',
          featuredLink: item.innerText.startsWith(self.featuredLinkPrefix),
          childLinks: [],
          depth: item.dataset.depth,
          left: left,
          last: item.dataset.last
        };

        if (group.level == 1) {
          group.parentHandle = group.handle;
          self.data.megaMenu.push(group)
          parentGroup = self.data.megaMenu[self.data.megaMenu.length - 1];
        }
        else if (group.level == 2){
          group.parentHandle = parentGroup.handle;
          parentGroup.childLinks.push(group);
          subGroup = parentGroup.childLinks[parentGroup.childLinks.length - 1];

        }
        else if (group.level == 3){
          group.parentHandle = subGroup.handle;
          subGroup.childLinks.push(group);
          childGroup = subGroup.childLinks[subGroup.childLinks.length - 1];

        }
        else if (group.level == 4){
          group.parentHandle = childGroup.handle;
          childGroup.childLinks.push(group);
        }

      }

      self.data.activeMenu = self.data.megaMenu[0];
      
    },
    
    bindEvents: function(){
    	var self = this;

      var menuContainer = document.querySelector('[data-mega-menu-binder]');
      
      tinybind.bind(menuContainer, {
        menu: self.data,
        methods: {
          setSelectedMenu: function(event, binding) {
            self.setSelectedMenu(event, binding);
          },
          hideMenu: function(event, binding) {
            self.hideMenu(event, binding);
          },
          setSelectedGroup: function(event, binding){
            self.setSelectedGroup(event, binding)
          }
        }
      });
    },

    setSelectedGroup: function(event, binding){
      var self = this;
      var group = binding.group
      var level = group.level;

      switch(level) {
        case 1:
          self.data.tier_1 = group.childLinks || [];
          self.data.tier_1.active = group.handle;
          break;
        case 2:
          self.data.tier_2 = group.childLinks || [];
          self.data.tier_2.active = group.handle;
          self.data.tier_2.has_children = false;

          for (var i = 0; i < group.childLinks.length; i++) {
            if(group.childLinks[i].childLinks.length > 0){
              self.data.tier_2.has_children = true;
              break;
            } 
          }

          self.data.tier_3 = [];
          break;
        case 3:
          self.data.tier_3 = group.childLinks || [];
          self.data.tier_3.active = group.handle;
          break;
        default:
          // code block
      }

      
    },

    hideMenu: function(){
      var self = this;

      self.data.active = false;
    },

    setSelectedMenu: function(event, binding){
      var self = this;
      var handle = event.currentTarget.dataset.menu;

      self.data.activeMenu = self.data.megaMenu.find(function(item){
        if (item.handle == handle){
          return item;
        }
      });

      self.resetSelectedTiers();
      self.data.active = true;
    },

    resetSelectedTiers: function(){
      var self = this;

      self.data.tier_2 = [];
      self.data.tier_3 = [];
    },

    showMegaMenu: function(){
    	var self = this;
    	var menuContainers = document.querySelectorAll('[data-mega-menu]');

    	for (var i = 0; i < menuContainers.length; i++) {
    		var menuContainer = menuContainers[i];
    		menuContainer.classlist.addClass('hidden');
    	}
    	
    }
  });

  return MegaMenu;
})();

document.addEventListener("DOMContentLoaded", function(event) {
	var megaMenuItems = document.querySelectorAll('[data-menu]');
	if (megaMenuItems.length > 0){
	  var megaMenu = new window.odTheme.MegaMenu();

    for (var i = 0; i < megaMenuItems.length; i++) {
      var menuItem = megaMenuItems[i];
      menuItem.addEventListener('mouseover', function(){

        for (var k = 0; k < megaMenuItems.length; k++) {
          var menuItem = megaMenuItems[k];
          menuItem.classList.remove('active');
        }

        this.classList.add('active');

      });
    }

    var menuBar = document.querySelector('.header-navigation');
    menuBar.addEventListener('mouseleave', function(){
      for (var k = 0; k < megaMenuItems.length; k++) {
        var menuItem = megaMenuItems[k];
        menuItem.classList.remove('active');
      }
    });
	}
});